import {BillingTransaction} from "../../../models";
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class RefundDetailsPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<BillingTransaction>}
 */
export class RefundDetailsPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/refund-detail';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BillingTransaction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BillingTransaction(attributes);
    }

    /**
     * @param {Object.<string, *>} paginationData
     * @param {...*} params
     * @returns {PaginationCollection<M>}
     * @protected
     */
    newPaginationCollection(paginationData, ...params) {

        return {
            perPageOptions:   [ 10, 25, 50, 100 ],
            perPage:          paginationData.per_page,
            page:             paginationData.current_page,
            total:            paginationData.total,
            from:             paginationData.from,
            to:               paginationData.to,
            models:           paginationData.data.map((attributes) => this.newModel(attributes, ...params)),
            totalAmount:      paginationData.amount.total_amount,
        };
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/refund-details.service.js